<template>
  <div class="category-news__wrapper">
    <h2 class="category-news__title">
      <a-link :to="linkToCategoryPage">{{ categoryName }}</a-link>
    </h2>

    <a-lazy-hydrate when-visible>
      <a-visibility hide :on="[$breakpoint.mobile]">
        <ul class="category-news__articles">
          <li
            v-for="article in articles"
            :key="article.id"
            class="article-most-viewed__list-item"
          >
            <article-slot :article="article" />
          </li>
        </ul>
      </a-visibility>
    </a-lazy-hydrate>
    <a-lazy-hydrate when-visible>
      <a-visibility show :on="[$breakpoint.mobile]">
        <ul class="category-news__articles">
          <li
            v-for="article in mobileArticles"
            :key="article.id"
            class="article-most-viewed__list-item"
          >
            <article-slot :article="article" />
          </li>
        </ul>
      </a-visibility>
    </a-lazy-hydrate>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import mixins from '@/utils/mixins'
import ArticleSlot from 'shared/ArticleSlots/Fm/ArticlePage/AArticleSlotCategoryNews'

const ARTICLE_COUNT_TO_SHOW_ON_MOBILE = 4

export default {
  name: 'CategoryNews',
  mixins: [mixins.urlGenerators],
  components: { ArticleSlot },
  props: {
    categoryName: propValidator([PROP_TYPES.STRING]),
    categorySlug: propValidator([PROP_TYPES.STRING]),
    articles: propValidator([PROP_TYPES.ARRAY])
  },
  computed: {
    linkToCategoryPage() {
      return this.generateCategoryPath({ CategorySlug: this.categorySlug })
    },
    mobileArticles() {
      return this.articles.slice(0, ARTICLE_COUNT_TO_SHOW_ON_MOBILE)
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/local/mixins/grid';
@import '~assets/scss/local/styles/article';

.category-news__wrapper {
  .category-news__title {
    @extend .section-title;
  }

  .category-news__articles {
    margin-top: 15px;
    border-radius: 5px;

    $border: (
      $above-desktop-xl: 1px solid $c--gray-dark-1,
      $mobile: none
    );
    $padding: (
      $above-desktop-xl: 20px,
      $mobile: 0
    );

    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: repeat(6, minmax(0, 100%)),
        $desktop-lg: repeat(3, minmax(0, 100%)),
        $mobile: minmax(0, 100%)
      ),
      $columnGapSetup: (
        $above-desktop-xl: 25px,
        $tablet: 30px
      ),
      $rowGapSetup: (
        $desktop-xl: 45px,
        $desktop-lg: 25px
      )
    );

    @include gridBuilder($grid-setup);
    @include setStyleByBreakpoint('border', $border);
    @include setStyleByBreakpoint('padding', $padding);
  }
}
</style>
